import { Car } from "./car.model";
import { Container } from "./container.model";
import { DriverProcess } from "./driverProcess.model";
import { Poligon } from "./poligon.model";

export class SetGeneralZone{
    public containers?:Array<Container>
    public garbageCenter?:Container
    public polygon?:Poligon
    public companyId?:number
    public driverProcess?:DriverProcess
    public car?:Car
    public myLocationLat?:string
    public myLocationLng?:string
}